import * as basket from "../eaiws/basket";
import { ArticleItem } from "./ArticleItem";
export class UserArticleItem extends ArticleItem {
    get isOfmlArticle() {
        return (false);
    }
    /**
     * Sets the label (shortText) of this user article.
     */
    setLabel(pLabel) {
        return (ArticleItem.SetShortText(this, pLabel, true));
    }
    setShortText(pText) {
        return (ArticleItem.SetShortText(this, pText, true));
    }
    setManufacturerId(pId) {
        return (ArticleItem.SetManufacturerId(this, pId));
    }
    setSeriesId(pId) {
        return (ArticleItem.SetSeriesId(this, pId));
    }
    setArticleNumber(pArticleNumber) {
        return (ArticleItem.SetArticleNumber(this, pArticleNumber));
    }
    setPrice(pPurchasePrice, pSalesPrice, pCurrency) {
        const tProps = new basket.ItemProperties();
        tProps.article = new basket.ArticleProperties();
        tProps.article.purchasePrice = pPurchasePrice;
        tProps.article.purchaseCurrency = pCurrency;
        tProps.article.salesPrice = pSalesPrice;
        tProps.article.salesCurrency = pCurrency;
        return (this.setItemProperties(tProps, false, true));
    }
    setPurchasePrice(pPrice, pCurrency) {
        const tProps = new basket.ItemProperties();
        tProps.article = new basket.ArticleProperties();
        tProps.article.purchasePrice = pPrice;
        tProps.article.purchaseCurrency = pCurrency;
        return (this.setItemProperties(tProps, false, true));
    }
    setSalesPrice(pPrice, pCurrency) {
        const tProps = new basket.ItemProperties();
        tProps.article = new basket.ArticleProperties();
        tProps.article.salesPrice = pPrice;
        tProps.article.salesCurrency = pCurrency;
        return (this.setItemProperties(tProps, false, true));
    }
    setPriceDate(pDate) {
        const tProps = new basket.ItemProperties();
        tProps.article = new basket.ArticleProperties();
        tProps.article.priceDate = pDate;
        return (this.setItemProperties(tProps, false, false));
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    generateImageUrl() {
        this.mImageUrl = null;
        return Promise.resolve();
    }
}
